var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTenken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.07,56.62a1.658,1.658,0,0,1-.95-.29l-5.29-3.52a1.717,1.717,0,1,1,1.9-2.86l4.05,2.69,8-9.02a1.714,1.714,0,1,1,2.57,2.27L55.36,56.03a1.721,1.721,0,0,1-1.28.58Z",
    fill: "#002455"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.57,21.4H63.28V19.38a1.709,1.709,0,0,0-1.71-1.71H50.28a1.709,1.709,0,0,0-1.71,1.71V21.4h-.64c.03.49.07.97.07,1.46,0,.66-.05,1.32-.1,1.97h2.38a1.709,1.709,0,0,0,1.71-1.71V21.1h7.86v2.02a1.709,1.709,0,0,0,1.71,1.71h3.22v5.95H46.66a25.375,25.375,0,0,1-1.39,3.41c.03,0,.05.01.07.01H66.5a1.709,1.709,0,0,0,1.71-1.71V30.54h.93v38.6H42.7V38.23a25,25,0,0,1-3.43,3.62v29a1.709,1.709,0,0,0,1.71,1.71H70.85a1.709,1.709,0,0,0,1.71-1.71V28.83a1.709,1.709,0,0,0-1.71-1.71H68.21V24.83h6.64V74.86H36.98V43.64a25.646,25.646,0,0,1-3.43,1.94v31a1.709,1.709,0,0,0,1.71,1.71h41.3a1.709,1.709,0,0,0,1.71-1.71V23.11a1.709,1.709,0,0,0-1.71-1.71Z",
    fill: "#002455"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.23,15.08c-2.45,0-3.88,2.6-3.88,7.07,0,4.91,1.33,7.43,3.91,7.43s3.85-2.47,3.85-7.35-1.35-7.16-3.88-7.16Z",
    fill: "#002455"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.86,0A22.86,22.86,0,1,0,45.72,22.86,22.854,22.854,0,0,0,22.86,0ZM17.08,23.68a9.463,9.463,0,0,0,1.86-.15V26a11.043,11.043,0,0,0-1.86-.13H15.12l-.61,1.02v.37h2.54a9.267,9.267,0,0,0,1.86-.15v2.47a11.889,11.889,0,0,0-1.86-.13H14.51v.79a20.512,20.512,0,0,0,.14,2.72H10.92a23.91,23.91,0,0,0,.14-2.72v-.79H8.46a11.056,11.056,0,0,0-1.88.13V27.11a8.788,8.788,0,0,0,1.88.15h2.6v-.37l-.59-1.02H8.49A9.8,9.8,0,0,0,6.62,26V23.53a8.99,8.99,0,0,0,1.87.15h.73L7.05,19.97c-.36-.64-1.04-1.72-1.39-2.21H9.95a9.535,9.535,0,0,0,.8,1.92l2.03,4.04,2.05-4.04a9.365,9.365,0,0,0,.8-1.92H19.9c-.31.47-1.21,1.94-1.37,2.21l-2.15,3.71h.71Zm20.76,6.29a8.435,8.435,0,0,1-7.61,4.28,8.421,8.421,0,0,1-6.3-2.55,8.671,8.671,0,0,1-1.9-3.04,19.012,19.012,0,0,1-1.02-6.28,16.673,16.673,0,0,1,1.64-7.59,8.382,8.382,0,0,1,7.58-4.33,8.452,8.452,0,0,1,8.23,5.59,19.046,19.046,0,0,1,1.02,6.3,16.84,16.84,0,0,1-1.64,7.62Z",
    fill: "#002455"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTenken);
export default __webpack_public_path__ + "static/media/icon_tenken.68b3edb288104f0a89ee15600e7608a9.svg";
export { ForwardRef as ReactComponent };